<template>
    <div id="auth">
        <main id="main">
            <nuxt />
        </main>
    </div>
</template>

<script>
    import translatableLayout from '@/mixins/translatableLayout';
    import themeableLayout from '@/mixins/themeableLayout';

    export default {
        name: 'auth',
        mixins: [translatableLayout, themeableLayout]
    }
</script>

<style scoped lang="scss">
    #auth {
        display: flex;
        min-height: 100vh;
    }
</style>
